export default __webpack_public_path__ + "static/media/pause.5c48e980.svg";